import { useAuth } from '@/hooks/useAuth';
import ProfileForm from '@/components/profile/ProfileForm';
import PasswordChangeForm from '@/components/profile/PasswordChangeForm';
import { updateProfile } from '@/api/auth';
import MfaSetup from '@/components/profile/MfaSetup';
import AvatarUpload from '@/components/profile/AvatarUpload';
import {useNavigate} from 'react-router-dom';
import IdentityPanel from '@/components/profile/IdentityPanel';
import AiConnectionsPanel from '@/components/settings/AiConnectionsPanel';

export default function CoreProfilePage() {
  const {user,updateUser,logout} = useAuth();const navigate=useNavigate();
  if (!user) return null;
  return <div className="max-w-2xl space-y-6">
    <h1 className="text-2xl font-bold text-gray-900">Profile</h1>
    <div className="card"><AvatarUpload avatarUrl={user.avatar_url} fullName={user.full_name} onAvatarChange={avatar_url=>updateUser({avatar_url})}/></div>
    <div className="card"><ProfileForm fullName={user.full_name} email={user.email} onSubmit={async values=>{updateUser(await updateProfile(values));}} /></div>
    <div className="card"><PasswordChangeForm /></div>
    <div className="card"><MfaSetup mfaEnabled={user.mfa_enabled} onMfaChange={enabled=>{updateUser({mfa_enabled:enabled});if(!enabled){logout();navigate('/login');}}}/></div>
    <IdentityPanel/>
    {/* Administrators manage AI connections under Org Settings; members see their own here. */}
    {!['customer_admin','platform_admin'].includes(user.role)&&<AiConnectionsPanel/>}
  </div>;
}
